import React from 'react';
import { portal, Portal } from '../../../../Configs/general';

import LogoHeaderGDC from './LogoHeader.GDC';
import LogoHeaderGDG from './LogoHeader.GDG';
import LogoHeaderEFG from './LogoHeader.EFG';

const LogoHeader = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <LogoHeaderGDC {...props} />;
    case Portal.Gasguajira:
      return <LogoHeaderGDG {...props} />;
    case Portal.Efigas:
      return <LogoHeaderEFG {...props} />;
    default:
      return <></>;
  }
};

export default LogoHeader;
